// extracted by mini-css-extract-plugin
module.exports = {"status":"LoanStatusHistory_status__1V_IV"};